const DELIVERY_MAPPINGS = {
  beforeCutoff: {
    0: { minDays: 4, targetDay: 'Wednesday' },  // Sunday -> Wednesday (4)
    1: { minDays: 3, targetDay: 'Wednesday' },  // Monday -> Wednesday (3)
    2: { minDays: 3, targetDay: 'Thursday' },   // Tuesday -> Thursday (3)
    3: { minDays: 3, targetDay: 'Friday' },     // Wednesday -> Friday (3)
    4: { minDays: 3, targetDay: 'Saturday' },   // Thursday -> Saturday (3)
    5: { minDays: 3, targetDay: 'Sunday' },     // Friday -> Sunday (3)
    6: { minDays: 5, targetDay: 'Wednesday' }   // Saturday -> Wednesday (5)
  },
  afterCutoff: {
    0: { minDays: 4, targetDay: 'Wednesday' },  // Sunday -> Wednesday (4)
    1: { minDays: 4, targetDay: 'Thursday' },   // Monday -> Thursday (4)
    2: { minDays: 4, targetDay: 'Friday' },     // Tuesday -> Friday (4)
    3: { minDays: 4, targetDay: 'Saturday' },   // Wednesday -> Saturday (4)
    4: { minDays: 4, targetDay: 'Sunday' },     // Thursday -> Sunday (4)
    5: { minDays: 6, targetDay: 'Wednesday' },  // Friday -> Wednesday (6)
    6: { minDays: 5, targetDay: 'Wednesday' }   // Saturday -> Wednesday (5)
  }
};

class DateUtils {
  constructor() {
    this.extraLeadTime = window.EXTRA_LEAD_TIME || 0;
    this.initializeCutoffTimes();
  }

  initializeCutoffTimes() {
    const defaultTimes = {
      0: { hour: 23, minutes: 59 },  // Sunday
      1: { hour: 10, minutes: 0 },   // Monday
      2: { hour: 12, minutes: 0 },   // Tuesday
      3: { hour: 12, minutes: 0 },   // Wednesday
      4: { hour: 11, minutes: 0 },   // Thursday
      5: { hour: 11, minutes: 0 },   // Friday
      6: { hour: 23, minutes: 59 }   // Saturday
    };

    this.cutoffTimes = Object.entries(window.CUTOFF_TIMES || {}).reduce((acc, [day, timeStr]) => {
      if (timeStr) {
        const [hours, minutes] = timeStr.split(':').map(num => parseInt(num));
        if (this.isValidTime({ hour: hours, minutes: minutes })) {
          acc[day] = { hour: hours, minutes: minutes };
          return acc;
        }
      }
      acc[day] = defaultTimes[day];
      console.warn(`Using default cutoff time for day ${day}:`, defaultTimes[day]);
      return acc;
    }, {});
  }

  isValidTime(time) {
    return time &&
           typeof time.hour === 'number' &&
           typeof time.minutes === 'number' &&
           time.hour >= 0 &&
           time.hour < 24 &&
           time.minutes >= 0 &&
           time.minutes < 60;
  }

  getSwitzerlandTime() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' }));
  }

  /**
   * Adds working days to a date, counting the current day as day 1
   * @param {Date} date - The starting date
   * @param {number} days - Number of days to add (including current day)
   * @returns {Date} The resulting date
   */
  addWorkingDays(date, days) {
    const result = new Date(date);
    result.setHours(0, 0, 0, 0);
    
    // Since we count current day as day 1, we subtract 1 from days to add
    const daysToAdd = Math.max(0, days - 1);
    
    for (let i = 0; i < daysToAdd; i++) {
      result.setDate(result.getDate() + 1);
    }
    
    return result;
  }

  setExtraLeadTime(days) {
    this.extraLeadTime = days;
    localStorage.setItem('extraLeadTime', days.toString());
    window.dispatchEvent(new CustomEvent('extraLeadTimeChanged', { detail: days }));
  }

  getExtraLeadTime() {
    return this.extraLeadTime;
  }

  isPastCutoff(currentHour, currentMinutes, cutoffTime) {
    return currentHour > cutoffTime.hour || 
           (currentHour === cutoffTime.hour && currentMinutes > cutoffTime.minutes);
  }

  calculateMinDate() {
    const switzerlandTime = this.getSwitzerlandTime();
    const currentDay = switzerlandTime.getDay();
    const currentHour = switzerlandTime.getHours();
    const currentMinutes = switzerlandTime.getMinutes();
    
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    /*console.log(`Current day: ${dayNames[currentDay]}`);
    console.log(`Current time: ${currentHour}:${currentMinutes}`);*/
    
    const todayCutoff = this.cutoffTimes[currentDay];
    /*console.log(`Cutoff time for today: ${todayCutoff.hour}:${todayCutoff.minutes}`);*/
    
    // Check if we're past cutoff
    const isPastCutoff = this.isPastCutoff(currentHour, currentMinutes, todayCutoff);
    /*console.log('Past cutoff time?', isPastCutoff);*/
    
    // Get delivery configuration based on cutoff status
    const deliveryConfig = DELIVERY_MAPPINGS[isPastCutoff ? 'afterCutoff' : 'beforeCutoff'][currentDay];
    let minDays = deliveryConfig.minDays;
    
    /*console.log(`Base configuration: ${minDays} days to ${deliveryConfig.targetDay}`);*/
    
    if (this.extraLeadTime > 0) {
      /*console.log('Adding extra lead time:', this.extraLeadTime);*/
      minDays += this.extraLeadTime;
    }
    
    const minDate = this.addWorkingDays(switzerlandTime, minDays);
    /*console.log('Final minimum date:', minDate.toLocaleString());*/
    
    return minDate;
  }

  updateNextCutoff() {
    const switzerlandTime = this.getSwitzerlandTime();
    const currentDay = switzerlandTime.getDay();
    const todayCutoff = this.cutoffTimes[currentDay];
    
    const cutoffTime = new Date(switzerlandTime);
    cutoffTime.setHours(todayCutoff.hour, todayCutoff.minutes, 0, 0);

    if (switzerlandTime > cutoffTime) {
      cutoffTime.setDate(cutoffTime.getDate() + 1);
      const nextDay = (currentDay + 1) % 7;
      const nextCutoff = this.cutoffTimes[nextDay];
      cutoffTime.setHours(nextCutoff.hour, nextCutoff.minutes, 0, 0);
    }

    return cutoffTime - switzerlandTime;
  }

  scheduleNextUpdate(picker) {
    const timeToNextUpdate = this.updateNextCutoff();
    
    setTimeout(() => {
      if (!picker.isShowning()) {
        picker.setMinDate(this.calculateMinDate());
      }
      this.scheduleNextUpdate(picker);
    }, timeToNextUpdate);
  }
}

// Initialize dateUtils globally
window.dateUtils = new DateUtils();

/**
 * SCAF date storage helpers
 *
 * Requirement:
 * - scaf-dates must always be stored as ISO UTC timestamps (with Z), e.g. 2025-01-05T10:00:00.000Z
 */
(function () {
  const KEY = 'scaf-dates';
  // Fixed hour to avoid accidental date rollovers when dates are rendered in local time.
  // Using midday UTC (12:00:00.000Z) gives maximum buffer against TZ shifts when reading/parsing.
  const UTC_HOUR_FOR_DATE = 12;

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  /**
   * Normalize a date string to YYYY-MM-DD.
   * Supports:
   * - YYYY-MM-DD
   * - YYYY-MM-DDTHH:mm:ss...
   * - DD/MM/YYYY
   */
  function normalizeToYmd(input) {
    if (!input || typeof input !== 'string') return null;

    const trimmed = input.trim();
    if (!trimmed) return null;

    // If it's ISO-like, keep only date part
    const isoLike = trimmed.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(isoLike)) return isoLike;

    // DD/MM/YYYY
    const dmy = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (dmy) {
      const d = Number(dmy[1]);
      const m = Number(dmy[2]);
      const y = Number(dmy[3]);
      if (isValidYmdParts(y, m, d)) return `${y}-${pad2(m)}-${pad2(d)}`;
    }

    return null;
  }

  function isValidYmdParts(y, m, d) {
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return false;
    if (y < 1000 || y > 9999) return false;
    if (m < 1 || m > 12) return false;
    if (d < 1 || d > 31) return false;

    // Validate actual calendar date using UTC to avoid local TZ effects
    const ms = Date.UTC(y, m - 1, d);
    const dt = new Date(ms);
    return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
  }

  function ymdToUtcMs(ymd) {
    const norm = normalizeToYmd(ymd);
    if (!norm) return null;
    const [y, m, d] = norm.split('-').map(Number);
    if (!isValidYmdParts(y, m, d)) return null;
    return Date.UTC(y, m - 1, d, UTC_HOUR_FOR_DATE, 0, 0, 0);
  }

  function buildPayload(startInput, endInput) {
    const startYmd = normalizeToYmd(startInput);
    const endYmd = normalizeToYmd(endInput);
    if (!startYmd || !endYmd) return null;

    const startUtcMs = ymdToUtcMs(startYmd);
    const endUtcMs = ymdToUtcMs(endYmd);
    if (startUtcMs == null || endUtcMs == null) return null;

    return {
      // REQUIRED: always store as ISO UTC timestamps (with Z)
      start_date: new Date(startUtcMs).toISOString(),
      end_date: new Date(endUtcMs).toISOString(),
      // Keep UTC timestamps (ms) for arithmetic/display
      start_utc_ms: startUtcMs,
      end_utc_ms: endUtcMs,
      // Convenience (date-only) values for wiring into <input type="date"> etc.
      start_ymd: startYmd,
      end_ymd: endYmd,
    };
  }

  function set(startInput, endInput, storage = window.sessionStorage) {
    const payload = buildPayload(startInput, endInput);
    if (!payload) return null;
    try {
      storage.setItem(KEY, JSON.stringify(payload));
      return payload;
    } catch (e) {
      return null;
    }
  }

  function get(storage = window.sessionStorage) {
    try {
      const raw = storage.getItem(KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;

      // Backwards compatible: allow existing { start_date, end_date } where values
      // might be YYYY-MM-DD or ISO timestamps.
      const startYmd = normalizeToYmd(parsed.start_date);
      const endYmd = normalizeToYmd(parsed.end_date);
      if (!startYmd || !endYmd) return null;

      // Prefer stored UTC ms, but derive if missing
      const startUtcMs = Number.isFinite(parsed.start_utc_ms) ? parsed.start_utc_ms : ymdToUtcMs(startYmd);
      const endUtcMs = Number.isFinite(parsed.end_utc_ms) ? parsed.end_utc_ms : ymdToUtcMs(endYmd);

      return {
        start_date: typeof parsed.start_date === 'string' && parsed.start_date.includes('T')
          ? parsed.start_date
          : new Date(startUtcMs).toISOString(),
        end_date: typeof parsed.end_date === 'string' && parsed.end_date.includes('T')
          ? parsed.end_date
          : new Date(endUtcMs).toISOString(),
        start_utc_ms: startUtcMs,
        end_utc_ms: endUtcMs,
        start_ymd: startYmd,
        end_ymd: endYmd,
      };
    } catch (e) {
      return null;
    }
  }

  function remove(storage = window.sessionStorage) {
    try {
      storage.removeItem(KEY);
    } catch (e) {
      // ignore
    }
  }

  function formatYmdForDisplay(ymd, locale = navigator.language) {
    const ms = ymdToUtcMs(ymd);
    if (ms == null) return '';
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
    }).format(new Date(ms));
  }

  function formatRangeForDisplay(startYmd, endYmd, locale = navigator.language) {
    const a = formatYmdForDisplay(normalizeToYmd(startYmd), locale);
    const b = formatYmdForDisplay(normalizeToYmd(endYmd), locale);
    if (!a || !b) return '';
    return `${a} - ${b}`;
  }

  // Expose
  window.ScafDates = {
    key: KEY,
    normalizeToYmd,
    ymdToUtcMs,
    buildPayload,
    set,
    get,
    remove,
    formatYmdForDisplay,
    formatRangeForDisplay,
  };
})();